import React from 'react';
import moment from 'moment';
import { isInclusivelyAfterDay } from 'react-dates';
import { FieldDateInput } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import { required } from '../../../util/validators';
import css from './EditListingDescriptionPageTwoDates.css';
import { useBefristetEndDateReset } from './hooks/useBefristetEndDateReset';

const EditListingDescriptionPageTwoDates = ({ form, showEndDate }) => {
    const { startDateRange, startDateBefristetDateStr } = useBefristetEndDateReset({
        form,
        isActive: showEndDate,
    });

    return (
        <div className={css.startDateWrapper}>
            <div className={css.startDateTitle}>
                <FormattedMessage id="EditListingDescriptionForm.startDateCalendarTitle" />
            </div>

            <FieldDateInput
                name="startDateBefristet"
                id="startDateBefristet"
                placeholderText={'Startdatum'}
                validate={required('Datum ist erforderlich')}
            />

            {showEndDate ? (
                <div className={css.endDateWrapper}>
                    <FieldDateInput
                        disabled={!startDateBefristetDateStr}
                        name="endDateBefristet"
                        id="endDateBefristet"
                        placeholderText={'Enddatum'}
                        validate={required('Datum ist erforderlich')}
                        isOutsideRange={day =>
                            !isInclusivelyAfterDay(
                                day,
                                moment().add(Math.abs(startDateRange), 'days')
                            )
                        }
                    />
                </div>
            ) : null}
        </div>
    );
};

export default EditListingDescriptionPageTwoDates;
